// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import VueSweetalert2 from 'vue-sweetalert2'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import VueRecaptcha from 'vue-recaptcha'

Vue.config.productionTip = false
Vue.use(Buefy)
Vue.use(VueSweetalert2)
Vue.use(VueRecaptcha)

Vue.filter('shortDate', value => {
  if (!value) return ''
  const date = new Date(value)
  return date.toLocaleDateString(['nl-NL'], {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  })
})

// Vue.util.on(window, 'beforeunload', () => alert('jj'), false)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js